import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[540px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20abstract%20background%20with%20warm%20golden%20and%20soft%20cream%20tones%2C%20geometric%20shapes%20subtle%20texture%2C%20professional%20tech%20community%20atmosphere%2C%20clean%20composition%20with%20gentle%20gradients%2C%20no%20text%2C%20warm%20inviting%20feel%2C%20sophisticated%20editorial%20style&width=1600&height=700&seq=hero-bg-2026&orientation=landscape"
        alt="第一版主 - 论坛版块管理核心指南"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
          第一版主
        </h1>
        <p className="text-lg md:text-2xl text-white/90 font-medium mb-3">
          论坛版块管理核心指南
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          深度解析第一版主的职责、权限、任命流程与管理技巧，帮助论坛运营者与版主候选人全面掌握第一版主的核心能力，打造高质量社区版块。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/zhize-quanxian"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            开始学习
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium text-sm rounded-md backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}